import axiosInstance from './axiosInstance'

export const getProjectInstallerPOById = (id) => {
  return axiosInstance.get(`/project-installer-pos/${id}`)
}

export const getProjectInstallerPOsByProjectId = (projectId) => {
  return axiosInstance.get(`/project-installer-pos/?projectId=${projectId}`)
}

// export const getProjectInstallerPOs = (page = 1, limit = 50, search = '', orderByKey = 'id', direction = 'asc') => {
//   return axiosInstance.get(`/project-installer-pos?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
// }

export const createProjectInstallerPO = (data) => {
  return axiosInstance.post('/project-installer-pos', data)
}

export const updateProjectInstallerPO = (id, data) => {
  return axiosInstance.put(`/project-installer-pos/${id}`, data)
}

export const approveProjectInstallerPO = (id, data) => {
  return axiosInstance.post(`/project-installer-pos/${id}/approve`, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const deleteProjectInstallerPO = (id) => {
  return axiosInstance.delete(`/project-installer-pos/${id}`)
}
